module.exports = jQuery;


/*****************
 ** WEBPACK FOOTER
 ** external "jQuery"
 ** module id = 3
 ** module chunks = 2 3
 **/